import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertService } from '../alert/alert.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  currentUrlSubject: BehaviorSubject<any>;
  currentPathSubject: BehaviorSubject<any>;
  currentUrlPublicSubject: BehaviorSubject<any>;
  currentUrlShareSubject: BehaviorSubject<any>;

  public = 'https://api-sidumas.badungkab.go.id/api/';
  prod_url = 'https://api-sidumas.badungkab.go.id/api/admin/';
  prod_path = 'https://api-sidumas.badungkab.go.id/';

  demo_url = 'https://demo-apisidumas.badungkab.go.id/api/admin/';
  demo_path = 'https://demo-apisidumas.badungkab.go.id/';

  prod_public_url = 'https://api-sidumas.badungkab.go.id/api/';

  demo_public_url = 'https://demo-apisidumas.badungkab.go.id/api/';

  constructor(public alertService: AlertService) {
    this.currentUrlSubject = new BehaviorSubject<any>(
      localStorage.getItem('url')
    );
    this.currentPathSubject = new BehaviorSubject<any>(
      localStorage.getItem('path')
    );
    this.currentUrlPublicSubject = new BehaviorSubject<any>(
      localStorage.getItem('url_public')
    );
    this.currentUrlShareSubject = new BehaviorSubject<any>(
      localStorage.getItem('url_share')
    );
  }

  get url(): any {
    return this.currentUrlSubject.value;
  }

  get path(): any {
    return this.currentPathSubject.value;
  }

  get url_public(): any {
    return this.currentUrlPublicSubject.value;
  }

  get url_share(): any {
    return this.currentUrlShareSubject.value;
  }

  setProd() {
    localStorage.setItem('url', environment.live.api_url);
    this.currentUrlSubject.next(environment.live.api_url);
    localStorage.setItem('path', environment.live.path_url);
    this.currentPathSubject.next(environment.live.path_url);
    localStorage.setItem('url_public', environment.live.public_url);
    this.currentUrlPublicSubject.next(environment.live.public_url);
    localStorage.setItem('url_share', environment.live.share_url);
    this.currentUrlShareSubject.next(environment.live.share_url);
  }

  async setDemo(version = '') {
    localStorage.setItem('url', environment.demo.api_url);
    this.currentUrlSubject.next(environment.demo.api_url);
    localStorage.setItem('path', environment.demo.path_url);
    this.currentPathSubject.next(environment.demo.path_url);
    localStorage.setItem('url_public', environment.demo.public_url);
    this.currentUrlPublicSubject.next(environment.demo.public_url);
    localStorage.setItem('url_share', environment.demo.share_url);
    this.currentUrlShareSubject.next(environment.demo.share_url);

    await this.alertService.showToast('Demo version ' + version, 'top');
  }
}
